export const tenantOptions = ({ smsList }) => smsList.tenantOptions;

export const smsInfo = ({ smsList }) => smsList.info;
